import React from "react";
import { I18n } from "react-redux-i18n";
import cx from 'classnames';

import { getTestAttributes } from "@common/utils/tests";
import { SkipLogicConditionCreateDto } from "@common/components/skip-logic/skip-logic.types";

import "./header.styles.scss";

type SkipLogicHeaderProps = {
  className?: string;
  columns: Array<{
    label: string;
    fieldName: keyof SkipLogicConditionCreateDto;
  }>
};

export const SkipLogicHeader: React.FC<SkipLogicHeaderProps> = ({ columns, className }) => {

  return (
    <thead className={cx("SkipLogic__header", className)}>
      <tr
        className="SkipLogic__header__row"
        {...getTestAttributes({
          id: "pan-query-fields-data-thead-row0-cell0",
        })}
      >
        <th
          className="SkipLogic__header__row__cell"
          {...getTestAttributes({
            id: "pan-query-fields-data-thead-row0-cell0",
          })}
        >
          {I18n.t("Type")}
        </th>
        {columns.map((column, columnIndex) => (
          <th
            key={column.fieldName}
            className="SkipLogic__header__row__cell"
            {...getTestAttributes({
              id: `pan-query-fields-data-thead-row0-cell${columnIndex + 1}`,
            })}
          >
            {column.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};
